import React, {Component} from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {AppContext} from "@lightspeed-invoicing/core-client/frontend";
import BillingMethodTotalLabel from "../../../common/pricing/billingmethodtotallabel.component.jsx"
import NumericLabel from 'react-pretty-numbers'
import Icon from "../../../common/icon/icon.component.jsx";
import PricingTableModal from "../pricingtablemodal.component.jsx";
import GlobalHelper from "../../../common/GlobalHelper.jsx";
import { Permissions, Guard } from "../../../role/Guard.jsx";

class QuoteProposedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
        this.handleOpenPricingTableModal = this.handleOpenPricingTableModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }

    handleOpenPricingTableModal(e) {
        e.preventDefault()
        this.setState({
            modal: <PricingTableModal
                quote={this.state.quote}
                onClose={this.handleCloseModal}
            />
        })
    }
    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    render() {
        let numberLabel = {
            justification: 'L',
            locales : AppContext.getLocale().getLanguage(),
            currency: true,
            currencyIndicator: AppContext.getCurrency(),
            percentage: false,
            precision: 0,
            commafy: false,
            shortFormat: true,
            title: true,
        }
        const billingMethods = GlobalHelper.unique(this.state.quote.attributes.items.map(r => r.attributes.billingMethod))
        return <div className={"row " + this.state.className}>
            {this.state.modal}
            <div className="col-12">
                <p>
                    <FormattedMessage
                        id="quote.analytics.events.quote_proposed_text"
                        defaultMessage="Proposal {identifier} has been proposed for a total value of {totalValue}"
                        values={{
                            identifier: <strong>{this.state.quote.attributes.identifier}</strong>,
                            totalValue: <strong><NumericLabel params={numberLabel}>
                                {this.state.quote.attributes.totalValue}
                            </NumericLabel></strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 col-md-6 col-lg-4'}>
                {this.state.quote.attributes.totals.filter(t => billingMethods.includes(t.attributes.billingMethod)).map((t, key) => {
                    const extra = (key === 1) ? 'bg-secondary text-white' : 'bg-custom-primary'
                    return <div key={key} className={'mb-2 px-3 ' + extra}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 text-white">
                                <strong>
                                    <BillingMethodTotalLabel value={t.attributes.billingMethod} billingMethodsCount={billingMethods.length} />
                                </strong>
                            </label>
                        </div>
                        <h5 className={'m-0 border-0 pb-0'}>
                            <FormattedNumber
                                value={t.attributes.totalAmount}
                                style={'currency'}
                                currency={t.attributes.currency}
                            />
                        </h5>
                        {t.attributes.marginRatio < 1 && Guard.isAuthorized(Permissions.ShowMargin)? <div className={'w-100'}>
                            <label className="col-form-label custom-form-label mt-0 pt-0 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="quote.analytics.margin_label"
                                        defaultMessage="Margin"
                                    />
                                </strong>
                            </label>
                        </div> : ''}
                        {t.attributes.marginRatio < 1 && Guard.isAuthorized(Permissions.ShowMargin)? <p className={'m-0 border-0'}>
                            <FormattedNumber
                                style="currency"
                                currency={t.attributes.currency}
                                value={t.attributes.margin}
                            />
                            &nbsp;
                            <small>
                                (<FormattedNumber
                                style="percent"
                                value={t.attributes.marginRatio}
                            />)
                            </small>
                        </p>: ''}
                    </div>
                })}
            </div>
            <div className={'col-12 col-md-6 col-lg-4'}>
                <p className={'mb-2'}>
                    <button className={'btn btn-sm btn-outline-primary'} onClick={this.handleOpenPricingTableModal}>
                        <Icon value={'dollar-sign'} className={'mr-1'}/>
                        <FormattedMessage
                            id="quote.analytics.events.pricing_table_btn"
                            defaultMessage="Show details"
                        />
                    </button>
                </p>
            </div>
        </div>
    }

}

export default QuoteProposedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-proposed.component.jsx